<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <v-card>
      <div>
        <v-card-title>
          <div class="headline">Coverage Details</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex  xs6  v-if="newCvr">
                <v-text-field :label="labels.cvrType" v-model="cvrForm.cvrType" :error-messages="errors.collect('cvrType')" data-vv-name="cvrType" :data-vv-as="labels.cvrType" v-validate="'required|param|max:4'" ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.cvrType}}</v-subheader>
                <div class="title">{{cvrForm.cvrType}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.cvrTypeDesc" v-model="cvrForm.cvrTypeDesc" :error-messages="errors.collect('cvrTypeDesc')" data-vv-name="cvrTypeDesc" :data-vv-as="labels.cvrTypeDesc" v-validate="'required|entry|max:40'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn color="primary" dark class="mb-2" @click="doNewCvr" v-if="newCvr">
          Add Coverage
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-btn color="primary" dark class="mb-2" @click="doUpdateCvr" v-else>
          Update Covergage
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <div v-if="!newCvr">
        <v-card-title>
          <div class="headline">Default Clause Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.clseNo }}</td>
            <td class="text-xs-left">{{ props.item.clseTitle }}</td>
            <td class="text-xs-left">{{ props.item.clseTxt }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" remove @remove="doPromptDelete(cvrType, props.item.clseNo)"></table-action>
            </td>
          </template>
        </v-data-table>
        <v-btn color="primary" dark class="mb-2" @click="doNewDefClse">
          Add Default Clause
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-dialog v-model="defClseDialog" width="800px" lazy persistent>
          <v-card>
            <v-card-title>
              <span class="headline">Default Clause</span>
            </v-card-title>
            <v-card-text>
              <message :messages="messages"></message>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-autocomplete :items="clseList" v-model="defClseForm.clseNo" :label="labels.clse" item-text="label" item-value="value" data-vv-name="clseNo" :data-vv-as="labels.clse" :error-messages="errors.collect('clseNo')" v-validate="'required'" @change="fetchClseTxt"></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12 v-if="defClseForm.clseNo != null">
                    <v-subheader class="queryLabel">{{labels.clseTxt}}</v-subheader>
                    <div class="title">{{query.clseTxt}}</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
              <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <confirm v-model="promptRemove" @ok="doDelete">
          Are you sure you want to delete the clause {{selectedId === null ? '' : selectedId.clseNo}}?
        </confirm>
      </div>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      title: 'Manage Coverage',
      breadcrumb: [],
      cvrForm: {
        cvrType: null,
        cvrTypeDesc: null
      },
      defClseForm: {
        cvrType: this.$route.params.cvrType,
        clseNo: null
      },
      query: {
        clseTitle: null,
        clseTxt: null
      },
      labels: {
        cvrType: 'Coverage Type*',
        cvrTypeDesc: 'Description*',
        clse: 'Clause*',
        clseTxt: 'Clause Text'
      },
      headers: [
        { text: 'Clause No', value: 'clseNo' },
        { text: 'Clause Title', value: 'clseTitle' },
        { text: 'Clause Text', value: 'clseTxt' },
        TableConst.tableActionHeader
      ],
      newCvr: true,
      newDefClse: false,
      defClseDialog: false,
      promptRemove: false,
      selectedId: null
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('coverage')
    this.breadcrumb.push({
      name: 'coverageReview',
      text: this.title
    })
    this.doInit()
  },
  methods: {
    doInit() {
      if (this.cvrType === 'new') {
        this.newCvr = true
      } else {
        this.newCvr = false
        this.doFetchGeneral()
        this.doFetchCvrDefClse(true)
      }
    },
    async doFetchGeneral() {
      const apiURI = this.coverageMenu.getCover
      if (apiURI) {
        try {
          const expand = {
            cover: this.cvrType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.cvrForm.cvrType = data.cover.cvrType
            this.cvrForm.cvrTypeDesc = data.cover.cvrTypeDesc
          }
        } catch (error) {

        }
      }
    },
    async doFetchCvrDefClse(option) {
      this.loading = true
      const apiURI = this.coverageMenu.getAllCvrDefClauses
      if (apiURI) {
        const expand = {
          cvrType: this.cvrType
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.items = []
          if (data) {
            data.map(cvrDefClse => {
              const convertList = {
                clseNo: cvrDefClse.clseNo,
                clseTitle: cvrDefClse.clseTitle,
                clseTxt: cvrDefClse.clseTxt
              }
              this.items.push(convertList)
            })
          }
        } catch (err) {

        }
      }
      this.loading = false
    },
    async fetchClseTxt() {
      this.resetMessages()
      this.resetValidator()
      this.query.clseTitle = this.query.clseTxt = ''
      const apiURI = this.coverageMenu.getClause
      if (apiURI) {
        try {
          const expand = {
            clseNo: this.defClseForm.clseNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (result.data) {
            this.query.clseTitle = data.clause.clseTxt
            this.query.clseTxt = data.clause.clseTxt
          }
        } catch (err) {

        }
      }
    },
    async doNewCvr() {
      this.resetMessages()
      const result = await this.$validator.validateAll()
      if (result) {
        const apiURI = this.coverageMenu.createCover
        if (apiURI) {
          try {
            const result = await this.$http.post(apiURI, this.cvrForm)
            const { data } = result
            if (data) {
              this.notify(data)
              const redirect = {
                name: 'coverage'
              }
              this.$router.push(redirect)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.promptFieldCheck()
      }
    },
    async doUpdateCvr() {
      this.resetMessages()
      const result = await this.$validator.validate('cvrTypeDesc')
      if (result) {
        const apiURI = this.coverageMenu.updateCover
        if (apiURI) {
          try {
            const result = await this.$http.put(apiURI, this.cvrForm)
            const { data } = result
            if (data) {
              this.notify(data)
              this.doFetchGeneral()
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.promptFieldCheck()
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newDefClse) {
            this.doCreateDefClse()
          } else {
            // update???
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateDefClse() {
      const apiURI = this.coverageMenu.createCvrDefClause
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.defClseForm)
          const data = result.data
          if (data) {
            this.notify(data)
            this.doFetchCvrDefClse(false)
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptDelete(cvrType, clseNo) {
      this.selectedId = {
        cvrType,
        clseNo
      }
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.coverageMenu.deleteCvrDefClause
      if (apiURI) {
        const expand = this.selectedId
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.doFetchCvrDefClse(false)
          this.doClose()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    doNewDefClse() {
      this.defClseDialog = true
      this.newDefClse = true
      this.initForm()
    },
    doClose() {
      this.defClseDialog = false
      this.newDefClse = false
      this.promptRemove = false
      this.initForm()
    },
    initForm() {
      this.resetValidator()
      this.resetMessages()
      this.defClseForm.clseNo = null
      this.selectedId = null
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    coverageMenu() {
      return this.$store.state.parameters.coverage.menu
    },
    clseList() {
      return this.$store.state.parameters.clseList
    },
    cvrType() {
      return this.$route.params.cvrType
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
